export type PortOption = {
  code: string
  name: string
}

export const usPorts: PortOption[] = [
  { code: '0101', name: 'Portland, ME' },
  { code: '0102', name: 'Bangor, ME' },
  { code: '0103', name: 'Eastport, ME' },
  { code: '0104', name: 'Jackman, ME' },
  { code: '0105', name: 'Vanceboro, ME' },
  { code: '0106', name: 'Houlton, ME' },
  { code: '0107', name: 'Fort Fairfield, ME' },
  { code: '0108', name: 'Van Buren, ME' },
  { code: '0109', name: 'Madawaska, ME' },
  { code: '0110', name: 'Fort Kent, ME' },
  { code: '0111', name: 'Bath, ME' },
  { code: '0112', name: 'Bar Harbor, ME' },
  { code: '0115', name: 'Calais, ME' },
  { code: '0118', name: 'Limestone, ME' },
  { code: '0121', name: 'Rockland, ME' },
  { code: '0122', name: 'Jonesport, ME' },
  { code: '0127', name: 'Bridgewater, ME' },
  { code: '0131', name: 'Portsmouth, NH' },
  { code: '0132', name: 'Belfast, ME' },
  { code: '0152', name: 'Searsport, ME' },
  { code: '0182', name: 'Manchester, NH' },
  { code: '0201', name: 'St. Albans, VT' },
  { code: '0203', name: 'Richford, VT' },
  { code: '0206', name: 'Beecher Falls, VT' },
  { code: '0207', name: 'Burlington International Airport' },
  { code: '0209', name: 'Derby Line, VT' },
  { code: '0211', name: 'Norton, VT' },
  { code: '0212', name: 'Highgate Springs, VT' },
  { code: '0214', name: 'Swanton, VT' },
  { code: '0401', name: 'Boston, MA' },
  { code: '0402', name: 'Springfield, MA' },
  { code: '0403', name: 'Worcester, MA' },
  { code: '0404', name: 'Gloucester, MA' },
  { code: '0405', name: 'New Bedford, MA' },
  { code: '0406', name: 'Plymouth, MA' },
  { code: '0407', name: 'Fall River, MA' },
  { code: '0408', name: 'Salem, MA' },
  { code: '0410', name: 'Bridgeport, CT' },
  { code: '0411', name: 'Hartford, CT' },
  { code: '0412', name: 'New Haven, CT' },
  { code: '0413', name: 'New London, CT' },
  { code: '0416', name: 'Lawrence, MA' },
  { code: '0417', name: 'Logan Airport' },
  { code: '0481', name: 'Hanscom User Fee Airport, Bedford, MA' },
  { code: '0501', name: 'Newport, RI' },
  { code: '0502', name: 'Providence, RI' },
  { code: '0503', name: 'Mellville, RI' },
  { code: '0606', name: 'Plymouth, MA' },
  { code: '0701', name: 'Ogdensburg, NY' },
  { code: '0704', name: 'Massena, NY' },
  { code: '0706', name: 'Cape Vincent, NY' },
  { code: '0708', name: 'Alexandria Bay, NY' },
  { code: '0712', name: 'Champlain, NY' },
  { code: '0714', name: 'Clayton, NY' },
  { code: '0715', name: 'Trout River, NY' },
  { code: '0901', name: 'Buffalo, NY' },
  { code: '0903', name: 'Rochester, NY' },
  { code: '0904', name: 'Oswego, NY' },
  { code: '0905', name: 'Sodus Point, NY' },
  { code: '0906', name: 'Syracuse, NY' },
  { code: '0907', name: 'Utica, NY' },
  { code: '0981', name: 'Binghamton, NY' },
  { code: '0982', name: 'Rome, NY' },
  { code: '1001', name: 'New York, NY' },
  { code: '1002', name: 'Albany, NY' },
  { code: '1101', name: 'Philadelphia, PA' },
  { code: '1102', name: 'Chester, PA' },
  { code: '1103', name: 'Wilmington, DE' },
  { code: '1104', name: 'Pittsburgh, PA' },
  { code: '1106', name: 'Wilkes-Barre Scranton, PA' },
  { code: '1107', name: 'Camden, NJ' },
  { code: '1108', name: 'Philadelphia International Airport' },
  { code: '1109', name: 'Harrisburg, PA' },
  { code: '1119', name: 'Allentown, PA' },
  { code: '1182', name: 'Atlantic City User Fee Airport, NJ' },
  { code: '1183', name: 'Trenton/Mercer Country User Fee Airport, NJ' },
  { code: '1195', name: 'UPS Courier Hub Facility, PA' },
  { code: '1301', name: 'Annapolis, MD' },
  { code: '1302', name: 'Cambridge, MD' },
  { code: '1303', name: 'Baltimore, MD' },
  { code: '1305', name: 'Balitmore- Washington International Airport, MD' },
  { code: '1401', name: 'Norfolk, VA' },
  { code: '1402', name: 'Newport News, VA' },
  { code: '1404', name: 'Richmond-Petersburg, VA' },
  { code: '1406', name: 'Cape Charles, VA' },
  { code: '1409', name: 'Charleston, WV' },
  { code: '1410', name: 'Front Royal, VA' },
  { code: '1412', name: 'New River Valley Airport, VA' },
  { code: '1481', name: 'New River Valley Airport' },
  { code: '1501', name: 'Wilmington, NC' },
  { code: '1502', name: 'Winston-Salem, NC' },
  { code: '1503', name: 'Raleigh-Durham, NC' },
  { code: '1511', name: 'Morehead City, NC' },
  { code: '1512', name: 'Charlotte, NC' },
  { code: '1581', name: 'Charlotte-Monroe Airport, NC' },
  { code: '1601', name: 'Charleston, SC' },
  { code: '1602', name: 'Georgetown, SC' },
  { code: '1603', name: 'Greenville-Spartanburg, SC' },
  { code: '1604', name: 'Columbia, SC' },
  { code: '1681', name: 'Myrtle Beach International Airport, SC' },
  { code: '1701', name: 'Brunswick, GA' },
  { code: '1703', name: 'Savannah, GA' },
  { code: '1704', name: 'Atlanta, GA' },
  { code: '1801', name: 'Tampa, FL' },
  { code: '1803', name: 'Jacksonville, FL' },
  { code: '1805', name: 'Fernandina Beach, FL' },
  { code: '1806', name: 'Carrabelle, FL' },
  { code: '1807', name: 'Boca Grande, FL' },
  { code: '1808', name: 'Orlando, FL' },
  { code: '1809', name: 'Sanford, FL' },
  { code: '1814', name: 'St. Petersburg, FL' },
  { code: '1816', name: 'Cape Canaveral, FL' },
  { code: '1817', name: 'Apalachicola, FL' },
  { code: '1818', name: 'Panama City' },
  { code: '1819', name: 'Pensacola, FL' },
  { code: '1820', name: 'Port St. Joe, FL' },
  { code: '1821', name: 'Port Manatee, FL' },
  { code: '1822', name: 'Fort Myers, FL' },
  { code: '1880', name: 'Naples, FL' },
  { code: '1881', name: 'Lakeland Linder Airport, FL' },
  { code: '1883', name: 'Sarasota, FL' },
  { code: '1884', name: 'Daytona Beach, FL' },
  { code: '1885', name: 'Melbourne, FL' },
  { code: '1887', name: 'Leesburg International Airport (UFA), FL' },
  { code: '1888', name: 'Orlando Executive Airport (UFA), FL' },
  { code: '1889', name: 'St. Augustine, FL' },
  { code: '1901', name: 'Mobile, AL' },
  { code: '1902', name: 'Gulfport, MS' },
  { code: '1903', name: 'Pascagoula, MS' },
  { code: '1904', name: 'Birmingham, AL' },
  { code: '1910', name: 'Huntsville, AL' },
  { code: '2001', name: 'Morgan City, LA' },
  { code: '2002', name: 'New Orleans, LA' },
  { code: '2003', name: 'Little Rock, AR' },
  { code: '2004', name: 'Baton Rouge, LA' },
  { code: '2006', name: 'Memphis, TN' },
  { code: '2007', name: 'Nashville, TN' },
  { code: '2008', name: 'Chattanooga, TN' },
  { code: '2010', name: 'Gramercy, LA' },
  { code: '2011', name: 'Greenville, MS' },
  { code: '2015', name: 'Vicksburg, MS' },
  { code: '2016', name: 'Knoxville, TN' },
  { code: '2017', name: 'Lake Charles, LA' },
  { code: '2018', name: 'Shreveport, LA' },
  { code: '2020', name: 'Lake Charles, LA' },
  { code: '2027', name: 'Tri-City User Fee Airport, Blountville, TN' },
  { code: '2081', name: 'Jackson Airport, Jackson, MS' },
  { code: '2082', name: 'Tri-City Airport, TN' },
  { code: '2084', name: 'Rogers Municipal Airport/Carter, Rogers, AR' },
  { code: '2095', name: 'Federal Express Courier, Memphis, TN' },
  { code: '2101', name: 'Port Arthur, TX' },
  { code: '2102', name: 'Sabine, TX' },
  { code: '2104', name: 'Beaumont, TX' },
  { code: '2301', name: 'Brownsville/Los Indios, TX' },
  { code: '2302', name: 'Del Rio, TX' },
  { code: '2303', name: 'Eagle Pass, TX' },
  { code: '2304', name: 'Laredo, TX' },
  { code: '2305', name: 'Hidalgo/Pharr, TX' },
  { code: '2307', name: 'Rio Grande City/Los Ebanos, TX' },
  { code: '2309', name: 'Progreso, TX' },
  { code: '2310', name: 'Roma/ Falcon Dam, TX' },
  { code: '2383', name: 'Harlingen Valley International Airport, TX' },
  { code: '2401', name: 'Ysleta, TX' },
  { code: '2402', name: 'El Paso, TX' },
  { code: '2403', name: 'Presidio, TX' },
  { code: '2404', name: 'Tornillo, TX' },
  { code: '2406', name: 'Columbus, NM' },
  { code: '2407', name: 'Albuquerque, NM' },
  { code: '2408', name: 'Santa Teresa, NM' },
  { code: '2481', name: 'Santa Teresa Airport, NM' },
  { code: '2482', name: 'Roswell Industrial Airport, Roswell, NM' },
  { code: '2501', name: 'San Diego, CA' },
  { code: '2502', name: 'Winterhaven, CA' },
  { code: '2503', name: 'Calexico West, CA' },
  { code: '2504', name: 'San Ysidro, CA' },
  { code: '2505', name: 'Tecate, CA' },
  { code: '2506', name: 'Otay Mesa, CA' },
  { code: '2507', name: 'Calexico East, CA' },
  { code: '2581', name: 'Palomar Airport, CA' },
  { code: '2601', name: 'Douglas, AZ' },
  { code: '2602', name: 'Lukeville, AZ' },
  { code: '2603', name: 'Naco, AZ' },
  { code: '2604', name: 'Nogales, AZ' },
  { code: '2605', name: 'Phoenix, AZ' },
  { code: '2606', name: 'Sasabe, AZ' },
  { code: '2608', name: 'San Luis, AZ' },
  { code: '2609', name: 'Tucson, AZ' },
  { code: '2681', name: 'Scottsdale, AZ' },
  { code: '2682', name: 'Mesa, AZ' },
  { code: '2704', name: 'Los Angeles, CA' },
  { code: '2707', name: 'Port San Luis, CA' },
  { code: '2709', name: 'Long Beach, CA' },
  { code: '2713', name: 'Port Hueneme, CA' },
  { code: '2720', name: 'Los Angeles, CA' },
  { code: '2721', name: 'Ontario, CA' },
  { code: '2722', name: 'Las Vegas, NV' },
  { code: '2774', name: 'Virgin Atlantic Cargo, Los Angeles, CA' },
  { code: '2775', name: 'TNT Express Worldwide, Los Angeles, CA' },
  { code: '2776', name: 'IBC PACIFIC, CA' },
  { code: '2781', name: 'Palm Springs, CA' },
  { code: '2782', name: 'San Bernardino International Airport, CA' },
  { code: '2783', name: 'Victorville, CA' },
  { code: '2786', name: 'MEADOWS FIELD AIRPORT, BAKERSFIELD, CA' },
  { code: '2791', name: 'DHL-HUB LOS ANGELES, CA' },
  { code: '2795', name: 'UPS, ONTARIO, CA' },
  { code: '2801', name: 'San Francisco, CA' },
  { code: '2802', name: 'Eureka, CA' },
  { code: '2803', name: 'Fresno, CA' },
  { code: '2805', name: 'Monterey, CA' },
  { code: '2809', name: 'San Francisco, CA' },
  { code: '2810', name: 'Stockton, CA' },
  { code: '2811', name: 'Oakland, CA' },
  { code: '2812', name: 'Richmond, CA' },
  { code: '2815', name: 'CROCKETT, CA' },
  { code: '2816', name: 'Sacramento, CA' },
  { code: '2820', name: 'MARTINEZ, CA' },
  { code: '2821', name: 'REDWOOD CITY, CA' },
  { code: '2827', name: 'SELBY, CA' },
  { code: '2828', name: 'SAN JUAQUIN RIVER, CA' },
  { code: '2829', name: 'SAN PABLO BAY, CA' },
  { code: '2830', name: 'CARQUINEZ STRAIT, CA' },
  { code: '2833', name: 'Reno, NV' },
  { code: '2834', name: 'San Jose, CA' },
  { code: '2835', name: 'SACRAMENTO INTL AIRPORT, CA' },
  { code: '2895', name: 'FEDERAL EXPRESS, OAKLAND, CA' },
  { code: '2901', name: 'Astoria, OR' },
  { code: '2902', name: 'Newport, OR' },
  { code: '2903', name: 'Coos Bay, OR' },
  { code: '2904', name: 'Portland, OR' },
  { code: '2905', name: 'Longview, WA' },
  { code: '2907', name: 'Boise, ID' },
  { code: '2908', name: 'Vancouver, WA' },
  { code: '2909', name: 'KALAMA, WA' },
  { code: '2910', name: 'Portland International Airport, Portland, WA' },
  { code: '2921', name: 'Natrona County Airport' },
  { code: '3001', name: 'Seattle, WA' },
  { code: '3002', name: 'Tacoma, WA' },
  { code: '3003', name: 'Aberdeen, WA' },
  { code: '3004', name: 'Blaine, WA' },
  { code: '3005', name: 'Bellingham, WA' },
  { code: '3006', name: 'Everett, WA' },
  { code: '3007', name: 'Port Angeles, WA' },
  { code: '3008', name: 'Port Townsend, WA' },
  { code: '3009', name: 'Sumas, WA' },
  { code: '3010', name: 'Anacortes, WA' },
  { code: '3011', name: 'Nighthawk, WA' },
  { code: '3012', name: 'Danville, WA' },
  { code: '3013', name: 'FERRY, WA' },
  { code: '3014', name: 'Friday Harbor, WA' },
  { code: '3015', name: 'BOUNDARY, WA' },
  { code: '3016', name: 'Laurier, WA' },
  { code: '3017', name: 'Point Roberts, WA' },
  { code: '3018', name: 'Kenmore Air Harbor, WA' },
  { code: '3019', name: 'Oroville Area Port, WA' },
  { code: '3020', name: 'Frontier, WA' },
  { code: '3022', name: 'Spokane, WA' },
  { code: '3023', name: 'Lynden, WA' },
  { code: '3025', name: 'Metaline Falls, WA' },
  { code: '3026', name: 'OLYMPIA, WA' },
  { code: '3027', name: 'Neah Bay, WA' },
  { code: '3029', name: 'Tacoma International Airport, Seattle, WA' },
  { code: '3071', name: 'UPS, SEATTLE, WA' },
  { code: '3082', name: 'Grant County Airport, Moses Lake, WA' },
  { code: '3101', name: 'Juneau, AK' },
  { code: '3102', name: 'Ketchikan, AK' },
  { code: '3103', name: 'Skagway, AK' },
  { code: '3104', name: 'Alcan, AK' },
  { code: '3105', name: 'Wrangell, AK' },
  { code: '3106', name: 'Dalton Cache, AK' },
  { code: '3107', name: 'Valdez, AK' },
  { code: '3111', name: 'Fairbanks, AK' },
  { code: '3115', name: 'Sitka, AK' },
  { code: '3126', name: 'Anchorage, AK' },
  { code: '3127', name: 'Kodiak, AK' },
  { code: '3195', name: 'FEDERAL EXPRESS, ANCHORAGE, AK' },
  { code: '3196', name: 'UPS Courier, Anchorage, AK' },
  { code: '3201', name: 'Honolulu, HI' },
  { code: '3202', name: 'Hilo, HI' },
  { code: '3203', name: 'Kahului, HI' },
  { code: '3204', name: 'Nawiliwili-Port Allen' },
  { code: '3205', name: 'Honolulu International Airport, HI' },
  { code: '3206', name: 'KAILUA-KONA, HI' },
  { code: '3301', name: 'Raymond, MT' },
  { code: '3302', name: 'Eastport, ID' },
  { code: '3303', name: 'Salt Lake City, UT' },
  { code: '3304', name: 'Great Falls, MT' },
  { code: '3305', name: 'Butte Airport, MT' },
  { code: '3306', name: 'Turner, MT' },
  { code: '3307', name: 'Denver, CO' },
  { code: '3308', name: 'Porthill, ID' },
  { code: '3309', name: 'Scobey, MT' },
  { code: '3310', name: 'Sweetgrass, MT' },
  { code: '3316', name: 'Piegan, MT' },
  { code: '3317', name: 'Opheim, MT' },
  { code: '3318', name: 'Roosville, MT' },
  { code: '3319', name: 'Morgan, MT' },
  { code: '3321', name: 'Whitlash, MT' },
  { code: '3322', name: 'Del Bonita, MT' },
  { code: '3323', name: 'Wild Horse, MT' },
  { code: '3324', name: 'Kalispell, MT' },
  { code: '3325', name: 'Willow Creek, MT' },
  { code: '3383', name: 'Broomfield, CO' },
  { code: '3384', name: 'Englewood, CO' },
  { code: '3385', name: 'Gypsum, CO' },
  { code: '3386', name: 'Bozeman Yellowstone User Fee Airport, MT' },
  { code: '3401', name: 'Pembina, ND' },
  { code: '3402', name: 'Noyes, MN' },
  { code: '3403', name: 'Portal, ND' },
  { code: '3404', name: 'Neche, ND' },
  { code: '3405', name: 'St. John, ND' },
  { code: '3406', name: 'Northgate, ND' },
  { code: '3407', name: 'Walhalla, ND' },
  { code: '3408', name: 'Hannah, ND' },
  { code: '3409', name: 'Sarles, ND' },
  { code: '3410', name: 'Ambrose, ND' },
  { code: '3411', name: 'Fargo-Hector International Airport, ND' },
  { code: '3413', name: 'Antler, ND' },
  { code: '3414', name: 'Sherwood, ND' },
  { code: '3415', name: 'Hansboro, ND' },
  { code: '3416', name: 'Maida, ND' },
  { code: '3417', name: 'Fortuna, ND' },
  { code: '3419', name: 'Westhope, ND' },
  { code: '3420', name: 'Noonan, ND' },
  { code: '3421', name: 'Carbury, ND' },
  { code: '3422', name: 'Dunseith, ND' },
  { code: '3423', name: 'Warroad, MN' },
  { code: '3424', name: 'Baudette, MN' },
  { code: '3425', name: 'Pinecreek, MN' },
  { code: '3426', name: 'Roseau, MN' },
  { code: '3427', name: 'Grand Forks, ND' },
  { code: '3428', name: 'Winnipeg International Airport' },
  { code: '3430', name: 'Lancaster, MN' },
  { code: '3433', name: 'Williston-Sloulin Field International Airport, ND' },
  { code: '3434', name: 'Minot International Airport, ND' },
  { code: '3450', name: 'Border Patrol Sector, Grand Forks, ND' },
  { code: '3452', name: 'Portal ND Border Patrol Station, ND' },
  { code: '3501', name: 'Minneapolis, MN' },
  { code: '3502', name: 'Sioux Falls, SD' },
  { code: '3510', name: 'Duluth, MN' },
  { code: '3512', name: 'Omaha, NE' },
  { code: '3513', name: 'Des Moines, IA' },
  { code: '3581', name: 'Rochester, MN' },
  { code: '3602', name: 'Ashland, WI' },
  { code: '3604', name: 'International Falls, MN' },
  { code: '3613', name: 'Grand Portage, MN' },
  { code: '3701', name: 'Milwaukee, WI' },
  { code: '3702', name: 'Marinette, WI' },
  { code: '3703', name: 'Green Bay, WI' },
  { code: '3706', name: 'Manitowoc, WI' },
  { code: '3707', name: 'Sheboygan, WI' },
  { code: '3708', name: 'Racine, WI' },
  { code: '3781', name: 'Appleton International Airport, WI' },
  { code: '3801', name: 'Detroit, MI' },
  { code: '3802', name: 'Port Huron, MI' },
  { code: '3803', name: 'Sault Sainte Marie, MI' },
  { code: '3804', name: 'Saginaw/Bay City/Flint, MI' },
  { code: '3805', name: 'Battle Creek, MI' },
  { code: '3806', name: 'Grand Rapids, MI' },
  { code: '3807', name: 'Detroit Metro Airport' },
  { code: '3808', name: 'Escanaba, MI' },
  { code: '3814', name: 'Algonac, MI' },
  { code: '3815', name: 'Muskegon, MI' },
  { code: '3819', name: 'Detour City, MI' },
  { code: '3881', name: 'Oakland-Pontiac Airport Waterford, MI' },
  { code: '3882', name: 'Willow Run Airport Ypsilanti, MI' },
  { code: '3883', name: 'Capital Region International Airport Lansing, MI' },
  { code: '3901', name: 'Chicago, IL' },
  { code: '3902', name: 'Peoria, IL' },
  { code: '3905', name: 'Gary, IN' },
  { code: '3908', name: 'Davenport, IA' },
  { code: '3909', name: 'Rockford, IL' },
  { code: '3910', name: 'Midway International Airport, Chicago, IL' },
  { code: '3971', name: 'TNT EXPRESS CONSIGNMENT, CHICAGO, IL' },
  { code: '3972', name: 'ECCF IBC Chicago, IL' },
  { code: '3981', name: 'Waukegan, IL' },
  { code: '3983', name: 'Wheeling Airport' },
  { code: '3984', name: 'West Chicago Airport' },
  { code: '3985', name: 'Decatur Airport' },
  { code: '3991', name: 'Nippon Courier Hub, Chicago, IL' },
  { code: '4101', name: 'Cleveland, OH' },
  { code: '4102', name: 'Cincinnati, OH' },
  { code: '4103', name: 'Columbus, OH' },
  { code: '4104', name: 'Dayton, OH' },
  { code: '4105', name: 'Toledo-Sandusky, OH' },
  { code: '4106', name: 'Erie, PA' },
  { code: '4110', name: 'Indianapolis, IN' },
  { code: '4115', name: 'Louisville, KY' },
  { code: '4116', name: 'Evansville, IN' },
  { code: '4117', name: 'Huron, OH' },
  { code: '4122', name: 'Ashtabula, OH' },
  { code: '4170', name: 'Burlington Air Express, Toledo, OH' },
  { code: '4181', name: 'Wilmington, OH' },
  { code: '4182', name: 'Rickenbacker Airport, Columbus, OH' },
  { code: '4183', name: 'Fort Wayne, IN' },
  { code: '4184', name: 'Lexington, KY' },
  { code: '4185', name: 'Hulman Regional Airport, Terre Haute, IN' },
  { code: '4195', name: 'Emery Courier, Vandalia, OH' },
  { code: '4196', name: 'UPS Courier, Louisville, KY' },
  { code: '4197', name: 'DHL Courier, Cincinnati, OH' },
  { code: '4198', name: 'Federal Express Hub, Indianapolis, IN' },
  { code: '4501', name: 'Kansas City' },
  { code: '4503', name: 'St. Louis, MO' },
  { code: '4504', name: 'Wichita, KS' },
  { code: '4505', name: 'Springfield, MO' },
  { code: '4506', name: 'Spirit of St.Louis Aiport' },
  { code: '4581', name: 'Mascoutah Airport' },
  { code: '4601', name: 'Newark, NJ' },
  { code: '4602', name: 'Perth Amboy, NJ' },
  { code: '4681', name: 'Morristown Airport, NJ' },
  { code: '4701', name: 'John F Kennedy International Airport, NY' },
  { code: '4771', name: 'NYACC, Jamaica, NY' },
  { code: '4772', name: 'DHL Airways, Jamaica, NY' },
  { code: '4773', name: 'Emery Worldwide, Jamaica, NY' },
  { code: '4774', name: 'Air France, Jamaica, NY' },
  { code: '4778', name: 'TNT Skypak, Jamaica, NY' },
  { code: '4901', name: 'Aguadilla, PR' },
  { code: '4904', name: 'Fajardo, PR' },
  { code: '4906', name: 'Humacao, PR' },
  { code: '4907', name: 'Mayaguez, PR' },
  { code: '4908', name: 'Ponce, PR' },
  { code: '4909', name: 'San Juan, PR' },
  { code: '4913', name: 'Luis Munoz Marin International Airport' },
  { code: '5101', name: 'Port Charlotte, VI' },
  { code: '5102', name: 'Cruz Bay, VI' },
  { code: '5104', name: 'Saint Croix, VI' },
  { code: '5201', name: 'Miami Seaport, FL' },
  { code: '5202', name: 'Key West, FL' },
  { code: '5203', name: 'Fort Lauderdale, FL' },
  { code: '5204', name: 'West Palm Beach' },
  { code: '5205', name: 'Fort Pierce, FL' },
  { code: '5206', name: 'Miami International Airport, FL' },
  { code: '5210', name: 'Fort Lauderdale International Airport, FL' },
  { code: '5270', name: 'International Courier Association, Miami, FL' },
  { code: '5295', name: 'UPS Miami International Airport, Miami, FL' },
  { code: '5296', name: 'DHL WORLDWIDE EXPRESS, MIAMI, FL' },
  { code: '5297', name: 'Fedex Courier Hub, Miami, FL' },
  { code: '5298', name: 'IBC Courier Hub, Miami, FL' },
  { code: '5301', name: 'Houston, TX' },
  { code: '5306', name: 'Texas City, TX' },
  { code: '5309', name: 'Houston Intercontinental Airport, TX' },
  { code: '5310', name: 'Galveston, TX' },
  { code: '5311', name: 'Freeport, TX' },
  { code: '5312', name: 'Corpus Christi, TX' },
  { code: '5313', name: 'Port Lavaca/Point Comfort, TX' },
  { code: '5381', name: 'Sugar Land, TX' },
  { code: '5382', name: 'Conroe, TX' },
  { code: '5401', name: 'Sterling, VA' },
  { code: '5402', name: 'Alexandria, VI' },
  { code: '5501', name: 'Dallas/Fort Worth, TX' },
  { code: '5502', name: 'Amarillo, TX' },
  { code: '5503', name: 'Lubbock, TX' },
  { code: '5504', name: 'Oklahoma City, OK' },
  { code: '5505', name: 'Tulsa, OK' },
  { code: '5506', name: 'Austin, TX' },
  { code: '5507', name: 'San Antonio, TX' },
  { code: '5582', name: 'Midland, TX' },
  { code: '5583', name: 'Alliance Airport, TX' },
  { code: '5584', name: 'Addison Airport, TX' },
  { code: '5585', name: 'Mckinney, TX' },
  { code: '7404', name: 'CBP St. Croix Preclearance, St. Croix, Virgin Islands' },
  { code: '7421', name: 'CBP Bermuda Preclearance, Washington, DC' },
  { code: '7422', name: 'CBP Freeport Preclearance, Washington, DC' },
  { code: '8888', name: 'Test District' },
  { code: '9900', name: 'Customs HQ' },
  { code: '9997', name: 'Unknown Port Location' },
  { code: '9999', name: 'ZZZZZZZZZZZ' },
]
